import { Button } from '@cockpitai/components/atoms'
import { routesPath } from '@cockpitai/constants/routesPath'
import { useChatStore } from '@cockpitai/store/chat'
import { sendAnalyticsEvent } from '@cockpitai/utils/analytics'
import { useNavigate } from 'react-router-dom'

export function NewChat() {
  const navigate = useNavigate()

  const { clearMessages, setIsStartedChat } = useChatStore()

  const newChat = () => {
    clearMessages()

    navigate(routesPath.dashboard.chat, { replace: true })

    setIsStartedChat(false)

    sendAnalyticsEvent('header_menu_click', { name: 'novo_chat' })
  }

  return (
    <Button
      type="button"
      onClick={newChat}
      className="whitespace-nowrap border-transparent bg-gray-850 px-4 text-sm lg:rounded-r-none xl:text-base">
      Novo Chat
    </Button>
  )
}
